<script setup>
import Overlay from '@/components/Overlay.vue';
import { useWhiteLabel } from '@/store/useWhitelabel';

const {
    useGradient,
    reverseGradient,
    logo
} = useWhiteLabel();

</script>

<template>
    <v-app>
        <div
            class="Auth"
            :class="{
                '--gradient':useGradient,
                '--reverse-gradient':reverseGradient
            }"
        >
            <Overlay />
            <div class="Auth__logo">
                <img
                    :src="logo"
                    alt=""
                >
            </div>
            <router-view />
        </div>
    </v-app>
</template>

<style lang="scss">
.Auth {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    min-height: 100vh;
    justify-content: center !important;
    align-content: center !important;
    align-items: center !important;
    padding: 24px !important;
    background: var(--primary-500);
}

.Auth.--gradient {
    background: linear-gradient(145deg, var(--secondary-500) 0%, var(--primary-500) 100%);
}

.Auth.--gradient.--reverse-gradient {
    background: linear-gradient(145deg, var(--primary-500) 0%, var(--secondary-500) 100%);
}

.Auth__logo {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    height: auto;
    margin-bottom: 24px !important;

    img {
        max-width: 100px !important;
        margin: 0 !important;

        @media (min-width: 600px) {
            max-width: 180px !important;
        }
    }
}

.Auth__secondary-actions {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    flex: 0 0 100%;
    width: 100%;
}
</style>
